import { ReactionsCommentsQuery } from '../graphql/ReactionsCommentsQuery.graphql.ts';
import { ReactionsContentQuery } from '../graphql/ReactionsContentQuery.graphql.ts';
import type { ReactionsContentQuery as ReactionsContentQueryData } from '../graphql/__types__/ReactionsContentQuery.ts';
import type { ConfluenceReactionsContentQuery as ConfluenceReactionsContentQueryData } from '../graphql/__types__/ConfluenceReactionsContentQuery.ts';
import type { ReactionsCommentsQuery as ReactionsCommentsQueryData } from '../graphql/__types__/ReactionsCommentsQuery.ts';
import type { QueryData, ReactionsData } from '../reactionTypes.ts';

type getReactionsSummaryFn = (data?: QueryData | null) => ReactionsData | null | undefined;

export const getReactionsSummary: getReactionsSummaryFn = (data) => {
	if (!data) {
		return data;
	}

	if (isConfluenceContentReactions(data)) {
		return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
	}

	if (isContentReactions(data)) {
		return (data as ReactionsContentQueryData)?.content?.nodes?.[0]?.contentReactionsSummary;
	}

	if (isCommentReactions(data)) {
		return (data as ReactionsCommentsQueryData)?.comments?.nodes?.[0]?.reactionsSummary;
	}
};

const isConfluenceContentReactions = (
	data: QueryData,
): data is ConfluenceReactionsContentQueryData =>
	Boolean((data as ConfluenceReactionsContentQueryData).confluence_contentReactionsSummary);

const isContentReactions = (data: QueryData): data is ReactionsContentQueryData =>
	Boolean((data as ReactionsContentQueryData).content);

const isCommentReactions = (data: QueryData): data is ReactionsCommentsQueryData =>
	Boolean((data as ReactionsCommentsQueryData).comments);

const getReactionsContentQuery = () => {
	return ReactionsContentQuery;
};

export const getReactionsQueryInfo = (isComment, contentId, containerId) => {
	const query = isComment ? ReactionsCommentsQuery : getReactionsContentQuery();
	const queryVariables = isComment ? { contentId, containerId } : { contentId };

	return { query, queryVariables };
};
